const Success = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br min-h-[70vh]">
      <div className="bg-white p-12 rounded-2xl shadow-2xl text-center max-w-md">
        <div className="mb-6">
          <svg
            className="w-32 h-32 mx-auto text-green-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          გადახდა წარმატებულია
        </h1>
      </div>
    </div>
  );
};

export default Success;
